import React from 'react';

const Stats = () => {
    const stats = [
        { number: '500+', label: 'Successful Migrations' },
        { number: '99.9%', label: 'Uptime Maintained' },
        { number: '24/7', label: 'Support Available' },
        { number: '0', label: 'Data Loss Incidents' }
    ];

    return (
        <section className="py-12 bg-gray-50">
        <div className="container-width">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 text-center">
        {stats.map((stat, index) => (
            <div key={index}>
            <div className="text-3xl font-light text-primary-700 mb-2">
            {stat.number}
            </div>
            <div className="text-gray-600 text-sm">{stat.label}</div>
            </div>
        ))}
        </div>
        </div>
        </section>
    );
};

export default Stats;
